var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-action"},[(_vm.isDoClose)?_c('button',{staticClass:"close show-action",attrs:{"data-dismiss":"modal"},on:{"click":_vm.doCloseModal}},[_vm._v("×")]):_c('button',{staticClass:"close show-action",attrs:{"data-dismiss":"modal"}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }